import React from 'react';
import { ZERO_ADDRESS, DEFAULT_ETH_DECIMALS } from '@blockcatio/tabby-library/lib/constants';
import FormattedWei from '@blockcatio/tabby-library/lib/components/FormattedWei';
import FormattedTokenWei from '@blockcatio/tabby-library/lib/components/FormattedTokenWei';

import { isBN } from './helpers';

/**
 * Format a payment amount as proper amount with proper type suffix.
 *
 * @param {BN} amount
 * @param {String|address} tokenAddress?
 * @param {Object[]} tokenList?
 * @param {Number} decimals?
 * @returns {Node}
 */
const formatPaymentAmount = (
  amount,
  tokenAddress = '',
  tokenList = [],
  decimals = DEFAULT_ETH_DECIMALS,
) => {
  if (isBN(amount)) {
    if (!tokenAddress || tokenAddress === ZERO_ADDRESS) {
      return <FormattedWei wei={amount} decimals={decimals} />;
    }
    return (
      <FormattedTokenWei
        tokenList={tokenList}
        amount={amount}
        tokenAddress={tokenAddress}
        decimals={decimals}
      />
    );
  }
  return <span>--</span>;
};

export default formatPaymentAmount;



// WEBPACK FOOTER //
// ./src/utilities/formatPaymentAmount.js